import { useContext } from 'react';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import { MdSearch } from 'react-icons/md';
import { Grid, Button, FormControl, RadioGroup, FormControlLabel, Radio, Typography, MenuItem } from '@mui/material';
import { addOrdersContext } from './AddOrdersContext';
import { SearchType } from 'helpers/Enums';
import theme from 'assets';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { appUserContext } from 'helpers/services';

let Filters = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);

    let service = useContext(addOrdersContext);


    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sx={{ backgroundColor: '#e4e4e4' }}>
                <Typography variant="subtitle2">
                    {formatMessage({
                        id: service.searchOrder.searchType === SearchType.Orders
                            ? LocalizationIds.SearchOrders
                            : LocalizationIds.SearchWorkOrders
                    })}
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Formik
                    enableReinitialize={true}
                    validationSchema={service.searchRequestSchema}
                    initialValues={service.searchRequestSchema.getDefault()}
                    onSubmit={(values, action) => {
                        service.doSearch(values);
                        action.setSubmitting(false);
                    }}
                >
                    {formProps =>
                        <Form>
                            <Grid container alignItems="flex-end" style={{ marginBottom: theme.spacing(2) }}>
                                {service.searchType === "" &&
                                    <Grid item xs={12} md>
                                        <FormControl component="fieldset">
                                            <RadioGroup
                                                row
                                                value={formProps.values.searchType}
                                                onChange={(e: any) => {
                                                    formProps.setFieldValue('searchType', e.target.value)
                                                }}
                                            >
                                                <FormControlLabel
                                                    value={SearchType.Orders}
                                                    control={<Radio color="secondary" />}
                                                    label={formatMessage({ id: LocalizationIds.Orders })}
                                                />
                                                <FormControlLabel
                                                    value={SearchType.WorkOrders}
                                                    control={<Radio color="secondary" />}
                                                    label={formatMessage({ id: LocalizationIds.WorkOrders })}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                }
                                {formProps.values.searchType === SearchType.Orders &&
                                    <>
                                        <Grid item xs={12} md>
                                            <Field
                                                component={TextField}
                                                label={formatMessage({ id: LocalizationIds.OrderNumber })}
                                                name="orderNumber"
                                                size="small"
                                                variant="standard"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md>
                                            <Field
                                                component={TextField}
                                                select
                                                label={formatMessage({ id: LocalizationIds.Typology })}
                                                size="small"
                                                name="orderType"
                                                variant="standard"
                                            >
                                                <MenuItem value="">{formatMessage({ id: LocalizationIds.Any })}</MenuItem>
                                                <MenuItem value="M">M</MenuItem>
                                                <MenuItem value="G">G</MenuItem>
                                                <MenuItem value="E">E</MenuItem>
                                            </Field>
                                        </Grid>
                                    </>
                                }
                                {formProps.values.searchType === SearchType.WorkOrders &&
                                    <>
                                        <Grid item xs={12} md>
                                            <Field
                                                component={TextField}
                                                label={formatMessage({ id: LocalizationIds.WorkOrder })}
                                                name="workOrder"
                                                size="small"
                                                variant="standard"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md>
                                            <Field
                                                component={TextField}
                                                label={formatMessage({ id: LocalizationIds.CommercialCode })}
                                                name="articleId"
                                                size="small"
                                                variant="standard"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md>
                                            <Field
                                                component={TextField}
                                                label={formatMessage({ id: LocalizationIds.ArticleModel })}
                                                name="articleModel"
                                                size="small"
                                                variant="standard"
                                            />
                                        </Grid>
                                    </>
                                }
                                <Grid item xs={12} md>
                                    <Button
                                        type="submit"
                                        variant="outlined"
                                        color="secondary"
                                        fullWidth={isMobile}
                                    >
                                        <MdSearch />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    }
                </Formik>
            </Grid>
        </Grid>
    )
}

export default Filters;